/**
 * getCompositeConfiguration
 *
 * Get the composite configuration from the composite data.
 *
 * @return {Object|null} Composite configuration or null if not set yet.
 */
export function getCurrentCompositeConfiguration() {
	if ( ! window?.QalaB2bWholesale?.composite?.api.get_composite_configuration ) {
		return null;
	}

	return window.QalaB2bWholesale.composite.api.get_composite_configuration();
}

/**
 * isCompositeProductActive
 *
 * Check if the composite product is active.
 *
 * @return {boolean} Whether the composite product is active or not.
 */
export function isCompositeProductActive() {
	return !! window?.QalaB2bWholesale?.composite;
}
